import { useTranslation } from 'react-i18next';
import { Button } from '../../components';
import { DisplayUtils } from '../../utils';
import './MainLayout.scss';

const MainLayout = ({
  title, 
  onBack,
  children
}) => {
  const { t } = useTranslation();

  return (
    <div className="MainLayout">
      <div className="w-100 d-flex justify-content-center">
        {!DisplayUtils.isMobile() ? (
          <img src="/misc/icons/complete_logo_white.svg" alt="shop-icon" className="MainLayout__logo" />
        ) : (
          <div className="MainLayout__title">
            <Button
              icon="/misc/icons/arrow-left-blue.svg"
              action={onBack}
              className="p-2 button-only-icon me-2"
              a11y={t('Globals.return')}
            />
            <h1>{title}</h1>
          </div>
        )}
      </div>
      <div className="w-100 d-flex justify-content-center">
          <div className="MainLayout__container">
            {!DisplayUtils.isMobile() && (
              <div className="MainLayout__container__title">
                <Button
                  icon="/misc/icons/arrow-left-pink.svg"
                  action={onBack}
                  className="p-2 button-only-icon me-2"
                  a11y={t('Globals.return')}
                />
                <h1>{title}</h1>
              </div>
            )}
            { children }
          </div>
      </div>
    </div>
  );
}

export default MainLayout;